import { saveAs } from 'file-saver';

export const saveFile = async (apiResponse) => {
    if (apiResponse.ok) {
        var disposition = apiResponse.headers.get('Content-Disposition');
        var defaultFileName = '';
        if (disposition) {
            var match = disposition.match(/.*filename="?([^;"]+)"?.*/);
            if (match[1])
                defaultFileName = match[1];
        }
        defaultFileName = defaultFileName.replace(/[<>:"/\\|?*]+/g, '_');

        apiResponse.blob().then(blob => {
            saveAs(blob, defaultFileName);
        })
    } else {
        const json = await apiResponse.json()
        if (json && json.message) {
            throw new Error(json.message);
        } else {
            throw new Error(`${apiResponse.status} ${apiResponse.statusText}`);
        }
    }
}